import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const StyName = styled(Box, {
    name: 'StyNoColorLink',
})({
    display: 'flex',
    alignItems: 'center',
});

export const StySynthesisHeader = styled(Box, {
    name: 'StySynthesisHeader',
})({
    display: 'flex',
    alignItems: 'center',
    padding: '2em 0 1em 0',
    gap: '1em',
    width: 'fit-content',
});
